export const CEZ_PATH = "/empresas/consejo-empresarial-sumapaz";

export const CEZ_EMAIL = "colaboradores@meu-aliado.com";

export const CEZ_WHATSAPP_AFILIACION =
  "https://wa.me/573213213635?text=" +
  encodeURIComponent(
    "Hola, me interesa afiliarme al CEZ — Consejo Empresarial del Sumapaz. ¿Podemos conversar?"
  );

export const CEZ_WHATSAPP_CAPITULO =
  "https://wa.me/573213213635?text=" +
  encodeURIComponent(
    "Hola, quiero información sobre el capítulo Fusagasugá Plateada del CEZ."
  );

const es = {
  brand: {
    sigla: "CEZ",
    nombre: "Consejo Empresarial del Sumapaz",
    tagline: "Gremio de la provincia del Sumapaz",
  },
  chrome: {
    menuLabel: "Navegar",
    volverEmpresas: "Volver a MEU Empresas",
    afiliarse: "Quiero afiliarme",
    abrirMenu: "Abrir menú CEZ",
    cerrarMenu: "Cerrar menú CEZ",
  },
  hero: {
    eyebrow: "CEZ · Consejo Empresarial del Sumapaz",
    title: "Un gremio para las empresas que mueven el Sumapaz",
    subtitle:
      "Reunimos en una sola mesa a los empresarios de salud, construcción, turismo y agroindustria de la provincia. El objetivo es sencillo: hablar con una sola voz, hacer negocios entre nosotros y traer inversión a los diez municipios.",
    ctaAfiliacion: "Quiero afiliarme",
    ctaCapitulo: "Conocer Fusagasugá Plateada",
    quote:
      "Solos competimos por migajas. Juntos negociamos de igual a igual.",
  },
  nav: [
    { label: "Quiénes somos", path: "/empresas/consejo-empresarial-sumapaz/quienes-somos" },
    { label: "Sectores", path: "/empresas/consejo-empresarial-sumapaz/sectores" },
    { label: "Fusagasugá Plateada", path: "/empresas/consejo-empresarial-sumapaz/fusagasuga-plateada" },
    { label: "El plan", path: "/empresas/consejo-empresarial-sumapaz/el-plan" },
    { label: "Cómo nos organizamos", path: "/empresas/consejo-empresarial-sumapaz/organizacion" },
    { label: "Afiliación", path: "/empresas/consejo-empresarial-sumapaz/afiliacion" },
  ],
  pageBanners: {
    inicio: {
      eyebrow: "CEZ · Consejo Empresarial del Sumapaz",
      title: "Un gremio para las empresas que mueven el Sumapaz",
      subtitle:
        "Reunimos en una sola mesa a los empresarios de salud, construcción, turismo y agroindustria de la provincia.",
    },
    quienesSomos: {
      eyebrow: "Quiénes somos",
      title: "Un gremio de provincia, con los pies en la tierra",
      subtitle: "Empresarios que se sientan en la misma mesa, deciden qué pelear primero y hacen seguimiento a lo acordado.",
    },
    sectores: {
      eyebrow: "Sectores",
      title: "Cuatro sectores, una misma provincia",
      subtitle: "Salud, construcción, turismo y agroindustria: los que más empleo formal generan y, bien organizados, se compran entre ellos.",
    },
    capitulo: {
      eyebrow: "Capítulo del CEZ",
      title: "Fusagasugá Plateada",
      subtitle: "El primer frente de trabajo donde los cuatro sectores atienden a un mismo cliente: el adulto mayor.",
    },
    plan: {
      eyebrow: "Plan de trabajo",
      title: "Cómo lo vamos a hacer, por etapas",
      subtitle: "Cuatro etapas con objetivo, acciones y una forma concreta de saber si se cumplió.",
    },
    gobierno: {
      eyebrow: "Cómo nos organizamos",
      title: "Reglas claras desde el primer día",
      subtitle: "Asamblea, junta, mesas sectoriales y secretaría técnica: para que nadie decida solo y todos rindan cuentas.",
    },
    afiliacion: {
      eyebrow: "Afiliación",
      title: "Cómo se entra al CEZ",
      subtitle: "Estar formalizado y cumplir lo que se acuerda en la mesa. Todo lo demás lo construimos en el camino.",
    },
  },
  cifras: {
    label: "Etapa fundacional",
    title: "Con qué arrancamos",
    intro:
      "Estas son las metas del primer año, no cifras de un gremio ya consolidado. Las publicamos así porque preferimos que usted mida nuestro cumplimiento.",
    items: [
      { valor: "10", texto: "Municipios de la provincia del Sumapaz" },
      { valor: "4", texto: "Sectores en la primera etapa" },
      { valor: "1", texto: "Capítulo: Fusagasugá Plateada" },
      { valor: "60", texto: "Empresas afiliadas — meta del primer año" },
      { valor: "12", texto: "Encuentros empresariales al año" },
    ],
    nota:
      "La provincia del Sumapaz reúne a Fusagasugá, Arbeláez, Cabrera, Granada, Pandi, Pasca, San Bernardo, Silvania, Tibacuy y Venecia.",
  },
  proposito: {
    label: "Quiénes somos",
    title: "Un gremio de provincia, con los pies en la tierra",
    body:
      "El Sumapaz está a dos horas de Bogotá y eso lo cambia todo: nuestros clientes, nuestros proveedores y nuestra competencia están al otro lado de la montaña. Cada empresario lo enfrenta solo, negocia solo y pierde tiempo solo en los mismos trámites. El CEZ existe para cambiar esa costumbre. No somos una oficina que hace estudios: somos empresarios que se sientan en la misma mesa, deciden qué pelear primero y hacen seguimiento a lo acordado.",
    pilares: [
      {
        titulo: "Una sola voz",
        texto:
          "Representamos a los afiliados ante alcaldías, gobernación, cámara de comercio y gremios nacionales. Una carta firmada por sesenta empresas pesa distinto a sesenta cartas sueltas.",
      },
      {
        titulo: "Negocios entre socios",
        texto:
          "Lo que hoy se compra en Bogotá y se puede comprar aquí, se compra aquí. Empezamos con lo evidente: alimentos, obra, mantenimiento, transporte y servicios profesionales.",
      },
      {
        titulo: "Información para decidir",
        texto:
          "Un boletín corto y honesto cada trimestre: cómo va el empleo, qué pasó con los precios, cuánta gente llegó el fin de semana, cuánto cuesta hoy construir. Datos que caben en una página.",
      },
    ],
  },
  miembros: {
    label: "Miembros",
    title: "Empresas que ya se sientan en la mesa",
    intro: "Estos son algunos de los afiliados que impulsan el CEZ desde la etapa fundacional.",
  },
  alianzas: {
    title: "Nuestros convenios y alianzas",
    intro: "Instituciones con las que trabajamos para fortalecer la provincia del Sumapaz.",
  },
  noticias: {
    title: "Noticias",
    intro: "Lo que está pasando en el gremio y en la provincia del Sumapaz.",
    verMas: "Leer noticia",
    volver: "Volver a Quiénes somos",
    clavesLabel: "Puntos clave",
    otrasLabel: "Otras noticias",
    porLabel: "Por",
  },
  sectores: {
    label: "Nuestros sectores",
    title: "Cuatro sectores, una misma provincia",
    intro:
      "Arrancamos con cuatro sectores porque son los que generan más empleo formal en el Sumapaz y porque, bien organizados, se compran entre ellos. Cada uno tiene su mesa, su vocero y su propia lista de tareas.",
    mesaLabel: "Qué hace la mesa",
    retosLabel: "Lo que hoy nos frena",
    items: [
      {
        id: "salud",
        nombre: "Salud",
        lema: "Cuidar bien también es un negocio serio",
        porQue:
          "La provincia atiende pacientes de toda la región y recibe cada año a más adultos mayores que se vienen a vivir aquí. Eso sostiene clínicas, centros de cuidado, laboratorios, farmacias, terapias y servicios a domicilio.",
        retos: [
          "Pagos que llegan tarde y desordenan la caja del mes.",
          "Personal capacitado que se va a Bogotá por mejor salario.",
          "Requisitos y habilitaciones que cada uno resuelve por su cuenta.",
        ],
        mesa: [
          "Negociar en bloque plazos y condiciones de pago con las pagadoras.",
          "Formar auxiliares y cuidadores aquí mismo, con la academia local.",
          "Comprar insumos en conjunto para bajar el costo unitario.",
        ],
      },
      {
        id: "construccion",
        nombre: "Construcción",
        lema: "Crecer sin dañar el jardín que nos da de comer",
        porQue:
          "Fusagasugá y Silvania llevan años recibiendo segunda vivienda, vivienda de retiro y proyectos de finca. Detrás de cada obra hay constructores, ferreterías, transportadores, maestros y proveedores locales.",
        retos: [
          "Licencias y servicios públicos que definen si un proyecto arranca o se queda en el papel.",
          "Mano de obra calificada escasa en acabados y obra segura.",
          "Financiación cara para el constructor pequeño y mediano.",
        ],
        mesa: [
          "Una sola interlocución técnica con planeación municipal y las empresas de servicios.",
          "Banco de proveedores y contratistas de la provincia, con referencias verificadas.",
          "Formación en obra segura y acabados, para dejar de importar cuadrillas.",
        ],
      },
      {
        id: "turismo",
        nombre: "Turismo",
        lema: "Nuestra tarea es llenar la semana, no solo el domingo",
        porQue:
          "Estamos a la puerta de Bogotá, con clima estable todo el año, fincas, gastronomía y naturaleza. El problema no es que no venga gente: es que viene concentrada en dos días y deja poco.",
        retos: [
          "Ingresos apretados de lunes a viernes, con nómina fija toda la semana.",
          "Informalidad que castiga a quien sí cumple y factura.",
          "Promoción dispersa: cada negocio pauta solo y compite con el vecino.",
        ],
        mesa: [
          "Armar planes de semana: estadías largas, bienestar, descanso y eventos corporativos.",
          "Acompañar la formalización — registro, seguros y facturación — sin discursos.",
          "Promoción conjunta en Bogotá, con una sola marca de provincia.",
        ],
      },
      {
        id: "agroindustria",
        nombre: "Agroindustria",
        lema: "Del cultivo al producto con marca propia",
        porQue:
          "Café, mora, frutales, panela, lácteos, avicultura y flores. El Sumapaz produce bien, pero vende barato: entrega materia prima y compra de vuelta el producto terminado, con el margen ya cobrado por otro.",
        retos: [
          "Precios que se deciden lejos de la finca.",
          "Demasiados intermediarios entre el productor y el cliente final.",
          "Poca transformación, empaque y marca propia.",
        ],
        mesa: [
          "Compra conjunta de insumos y empaque, con volumen real de negociación.",
          "Una marca de origen del Sumapaz con reglas mínimas de calidad.",
          "Vender aquí: a los hoteles, restaurantes, colegios y centros de cuidado de la provincia.",
        ],
      },
    ],
  },
  capitulo: {
    label: "Capítulo del CEZ",
    title: "Fusagasugá Plateada",
    intro:
      "Un capítulo es un frente de trabajo donde los cuatro sectores atienden a un mismo cliente. Este es el primero, y nace de algo que en Fusagasugá se ve en la calle todos los días.",
    queEsTitle: "De qué se trata",
    queEs: [
      "Fusagasugá lleva décadas recibiendo a personas que llegan a vivir su etapa de retiro: clima amable, cerca de Bogotá, ciudad tranquila. Muchas llegan con una pensión que entra al municipio todos los meses.",
      "A eso le llamamos economía plateada: todo lo que una ciudad produce para atender bien a los adultos mayores. Vivienda, salud, alimentación, descanso, compañía y servicios en casa.",
      "No es asistencia social ni caridad. Es un mercado que ya existe, que hoy se atiende a medias y de manera informal, y que hasta ahora nadie ha organizado.",
    ],
    porQueTitle: "Por qué Fusagasugá y por qué ahora",
    porQue: [
      {
        titulo: "El ingreso llega todos los meses",
        texto:
          "Una pensión no depende de la cosecha, ni del clima, ni del puente festivo. Es el ingreso más estable que entra al municipio y no se va cuando termina el fin de semana.",
      },
      {
        titulo: "El país está envejeciendo",
        texto:
          "Cada año hay más personas mayores de sesenta años en Colombia y más gente eligiendo dónde pasar el retiro. Fusagasugá ya está en esa lista; la pregunta es si va a estar preparada.",
      },
      {
        titulo: "Hoy se atiende de manera improvisada",
        texto:
          "Buen cuidado, casas adaptadas, comida apropiada y actividades existen, pero sueltos y sin garantía. Ahí está la oportunidad para quien lo haga en serio.",
      },
      {
        titulo: "Ordena la ciudad, no solo el negocio",
        texto:
          "Una ciudad cómoda para un adulto mayor —andenes buenos, cerca de todo, tranquila y segura— es una ciudad mejor para todos los que vivimos aquí.",
      },
    ],
    convergenciaTitle: "Cómo entran los cuatro sectores",
    convergencia: [
      {
        id: "salud",
        titulo: "Salud",
        texto:
          "Cuidado en casa, terapias, controles, rehabilitación y centros de atención de día. Servicio cerca, con personal formado aquí y precios claros desde el principio.",
      },
      {
        id: "construccion",
        titulo: "Construcción",
        texto:
          "Vivienda pensada para vivir bien a los setenta: sin escaleras innecesarias, pisos que no resbalan, baños seguros, buena luz. Y remodelación de las casas que ya existen.",
      },
      {
        id: "turismo",
        titulo: "Turismo",
        texto:
          "Estadías largas y descanso de semana, no solo paseo de domingo. Bienestar, termales, caminatas suaves, encuentros culturales y visitas de la familia que viene desde Bogotá.",
      },
      {
        id: "agroindustria",
        titulo: "Agroindustria",
        texto:
          "Alimentación apropiada: porciones adecuadas, menos sal y azúcar, productos frescos de la provincia, entregas a domicilio y a los centros de cuidado.",
      },
    ],
    ideaSimpleTitle: "La idea en una frase",
    ideaSimple:
      "Una misma persona puede ser cliente de los cuatro sectores en el mismo mes: vive en una casa que construimos, la atiende un servicio de salud de aquí, come lo que se produce aquí y descansa aquí. Si nos organizamos, ese dinero se queda en la provincia. Si no, se lo lleva Bogotá.",
    ctaCapitulo: "Quiero entrar al capítulo",
  },
  plan: {
    label: "Plan de trabajo",
    title: "Cómo lo vamos a hacer, por etapas",
    intro:
      "Un gremio se cae cuando promete todo para el primer año. Este plan está pensado en cuatro etapas, cada una con una tarea clara y una forma sencilla de saber si se cumplió.",
    objetivoLabel: "A qué apuntamos",
    accionesLabel: "Qué hacemos",
    medicionLabel: "Cómo sabemos si funcionó",
    fases: [
      {
        etiqueta: "Etapa 1",
        horizonte: "Meses 1 a 3",
        titulo: "Poner la mesa",
        objetivo:
          "Que el gremio exista de verdad: con reglas escritas, afiliados que firmaron y un vocero por sector.",
        acciones: [
          "Constituir el CEZ y aprobar estatutos y código de conducta.",
          "Levantar el listado de empresas formales de los cuatro sectores, municipio por municipio.",
          "Instalar las cuatro mesas sectoriales y elegir vocero en cada una.",
          "Abrir la secretaría técnica, que lleva actas, cuentas y seguimiento.",
        ],
        medicion:
          "Cuarenta empresas con carta de intención firmada y las cuatro mesas sesionando con vocero elegido.",
      },
      {
        etiqueta: "Etapa 2",
        horizonte: "Meses 4 a 6",
        titulo: "Saber en qué estamos parados",
        objetivo:
          "Cambiar la conversación de opiniones a hechos: cuántos somos, cuánto empleo generamos y cuánta plata se nos va de la provincia.",
        acciones: [
          "Una radiografía corta por sector: número de empresas, empleo y ventas aproximadas.",
          "Identificar qué compramos afuera que ya se podría comprar aquí.",
          "Mapa de lo que hoy existe para el adulto mayor en Fusagasugá y qué falta.",
          "Publicar el primer boletín del Sumapaz, de una página por sector.",
        ],
        medicion:
          "Un informe breve por sector, un mapa del capítulo y el primer boletín publicado.",
      },
      {
        etiqueta: "Etapa 3",
        horizonte: "Meses 7 a 12",
        titulo: "Primeros negocios y primeros acuerdos",
        objetivo:
          "Que el afiliado vea plata y no solo reuniones. Aquí el gremio se gana o se pierde.",
        acciones: [
          "Rueda de negocios entre socios: hoteles y centros de cuidado comprando a los productores de la provincia.",
          "Sello Fusagasugá Plateada, con requisitos mínimos verificables de calidad y trato.",
          "Convenios con la alcaldía, la cámara de comercio y la academia local.",
          "Formación en cuidado del adulto mayor, servicio al cliente y obra segura.",
        ],
        medicion:
          "Monto de compras entre afiliados, número de empresas con sello y personas formadas y certificadas.",
      },
      {
        etiqueta: "Etapa 4",
        horizonte: "Año 2",
        titulo: "Que se note afuera",
        objetivo:
          "Que Fusagasugá aparezca en el mapa como el mejor lugar del centro del país para vivir el retiro, y que eso traiga inversión.",
        acciones: [
          "Promoción del capítulo en Bogotá, con una sola marca y una sola vocería.",
          "Presentar a inversionistas proyectos concretos: vivienda con servicios y centros de cuidado.",
          "Agenda formal con la gobernación y las entidades nacionales del sector.",
          "Evaluar lo hecho, ajustar el plan y decidir el siguiente capítulo.",
        ],
        medicion:
          "Visitantes de lunes a viernes, unidades de vivienda adaptada en obra e inversión anunciada en la provincia.",
      },
    ],
    nota:
      "Cada etapa se aprueba en asamblea antes de arrancar la siguiente. Si algo no funciona, se dice y se corrige; no se maquilla.",
  },
  gobierno: {
    label: "Cómo nos organizamos",
    title: "Reglas claras desde el primer día",
    intro:
      "Los gremios se dañan por dos razones: porque nadie rinde cuentas o porque uno solo decide por todos. Así lo evitamos.",
    organos: [
      {
        titulo: "Asamblea de afiliados",
        texto:
          "Es la que manda. Aprueba el plan, la cuota anual y las cuentas. Un afiliado, un voto, sin importar el tamaño de la empresa.",
      },
      {
        titulo: "Junta directiva",
        texto:
          "Entre cinco y siete personas, con al menos un vocero de cada sector. Se renueva por mitades para que siempre entre gente nueva.",
      },
      {
        titulo: "Mesas sectoriales",
        texto:
          "Cuatro mesas: salud, construcción, turismo y agroindustria. Cada una define sus tres prioridades del año y responde por ellas.",
      },
      {
        titulo: "Comité Fusagasugá Plateada",
        texto:
          "Mesa mixta del capítulo: los cuatro sectores, la academia local y la administración municipal como invitada permanente.",
      },
      {
        titulo: "Secretaría técnica",
        texto:
          "MEU Aliado acompaña con los números, los informes y el seguimiento de compromisos. Sin voto en las decisiones del gremio.",
      },
    ],
  },
  afiliacion: {
    label: "Afiliación",
    title: "Cómo se entra al CEZ",
    intro:
      "Pedimos dos cosas: estar formalizado y cumplir lo que se acuerda en la mesa. Todo lo demás lo construimos en el camino.",
    beneficiosLabel: "Incluye",
    paraLabel: "Para quién es",
    categorias: [
      {
        nombre: "Emprende",
        para: "Persona natural formalizada y microempresa de la provincia.",
        destacado: false,
        beneficios: [
          "Boletín trimestral del Sumapaz.",
          "Participación en su mesa sectorial.",
          "Tarifa preferencial en formación y eventos.",
          "Ficha básica en el directorio de afiliados.",
        ],
      },
      {
        nombre: "Empresa",
        para: "Pequeña y mediana empresa con operación en el Sumapaz.",
        destacado: true,
        beneficios: [
          "Todo lo de Emprende.",
          "Rueda de negocios entre afiliados.",
          "Derecho a vocería en su mesa sectorial.",
          "Uso del sello Fusagasugá Plateada, cumpliendo los requisitos.",
          "Acompañamiento en trámites y convocatorias.",
        ],
      },
      {
        nombre: "Fundador",
        para: "Empresa o institución que respalda la etapa fundacional.",
        destacado: false,
        beneficios: [
          "Todo lo de Empresa.",
          "Silla en la junta directiva del primer periodo.",
          "Marca presente en eventos y publicaciones del gremio.",
          "Agenda directa en las visitas institucionales.",
          "Reconocimiento permanente como fundador.",
        ],
      },
    ],
    nota:
      "La cuota anual la fija la asamblea según el tamaño de la empresa, y se publica junto con las cuentas del año. Quien se afilie en el primer año conserva su condición de fundador.",
    cta: "Hablar de mi afiliación",
  },
  agenda: {
    label: "Agenda",
    title: "Lo que pasa durante el año",
    intro:
      "Un gremio se sostiene con encuentros que valen el tiempo del empresario. Estas son las actividades fijas del calendario.",
    items: [
      {
        titulo: "Desayuno empresarial",
        texto:
          "Una vez al mes, temprano y con hora de cierre respetada. Un tema, un invitado y tiempo real para conversar entre socios.",
      },
      {
        titulo: "Visita empresarial",
        texto:
          "Vamos a la planta, la obra, el hotel o la finca de un afiliado. Se aprende más viendo operar que oyendo presentaciones.",
      },
      {
        titulo: "Foro sectorial",
        texto:
          "Un encuentro por sector al año, con las autoridades que deciden y compromisos que quedan por escrito.",
      },
      {
        titulo: "Rueda de negocios",
        texto:
          "Citas cortas entre quien compra y quien vende dentro del gremio. Con agenda armada de antemano.",
      },
      {
        titulo: "Misión a Bogotá",
        texto:
          "Llevamos la oferta de la provincia a compradores, operadores turísticos e inversionistas de la capital.",
      },
      {
        titulo: "Formación",
        texto:
          "Talleres cortos y prácticos: cuidado del adulto mayor, servicio, costos, obra segura y manejo de la caja.",
      },
    ],
  },
  cierre: {
    title: "El Sumapaz no necesita otro estudio. Necesita organizarse.",
    body:
      "Si su empresa está en salud, construcción, turismo o agroindustria y opera en la provincia, hay una silla para usted en la mesa. Escríbanos y le contamos en qué va la etapa fundacional.",
    ctaWhatsapp: "Escribir por WhatsApp",
    ctaCorreo: "Escribir al correo",
    contactoLabel: "Contacto",
  },
  footer: {
    direccionLabel: "Dirección",
    direccion: "Fusagasugá, provincia del Sumapaz",
    lugar: "Cundinamarca, Colombia",
    correoLabel: "Correo",
    copyright: "Consejo Empresarial del Sumapaz CEZ — Todos los derechos reservados",
    asamblea: "Asamblea General de Asociados 2026",
    ayuda: "¿Necesitas ayuda?",
    escribenos: "Escríbenos",
  },
  back: "Volver a Empresas",
};

const en = {
  brand: {
    sigla: "CEZ",
    nombre: "Sumapaz Business Council",
    tagline: "Business council of the Sumapaz province",
  },
  chrome: {
    menuLabel: "Navigate",
    volverEmpresas: "Back to MEU Business",
    afiliarse: "I want to join",
    abrirMenu: "Open CEZ menu",
    cerrarMenu: "Close CEZ menu",
  },
  hero: {
    eyebrow: "CEZ · Sumapaz Business Council",
    title: "A business council for the companies that move Sumapaz",
    subtitle:
      "We bring health, construction, tourism, and agribusiness owners in the province to a single table. The goal is simple: speak with one voice, do business with each other, and bring investment to all ten municipalities.",
    ctaAfiliacion: "I want to join",
    ctaCapitulo: "Explore Silver Fusagasugá",
    quote: "Alone we compete for crumbs. Together we negotiate as equals.",
  },
  nav: [
    { label: "Who we are", path: "/empresas/consejo-empresarial-sumapaz/quienes-somos" },
    { label: "Sectors", path: "/empresas/consejo-empresarial-sumapaz/sectores" },
    { label: "Silver Fusagasugá", path: "/empresas/consejo-empresarial-sumapaz/fusagasuga-plateada" },
    { label: "The plan", path: "/empresas/consejo-empresarial-sumapaz/el-plan" },
    { label: "How we are organized", path: "/empresas/consejo-empresarial-sumapaz/organizacion" },
    { label: "Membership", path: "/empresas/consejo-empresarial-sumapaz/afiliacion" },
  ],
  pageBanners: {
    inicio: {
      eyebrow: "CEZ · Sumapaz Business Council",
      title: "A business council for the companies that move Sumapaz",
      subtitle:
        "We bring health, construction, tourism, and agribusiness owners in the province to a single table.",
    },
    quienesSomos: {
      eyebrow: "Who we are",
      title: "A provincial council with its feet on the ground",
      subtitle: "Business owners who sit at the same table, decide what to fight for first, and follow up on what was agreed.",
    },
    sectores: {
      eyebrow: "Sectors",
      title: "Four sectors, one province",
      subtitle: "Health, construction, tourism, and agribusiness: they create the most formal jobs and, properly organized, buy from each other.",
    },
    capitulo: {
      eyebrow: "CEZ chapter",
      title: "Silver Fusagasugá",
      subtitle: "The first working front where all four sectors serve the same client: older adults.",
    },
    plan: {
      eyebrow: "Work plan",
      title: "How we will do it, stage by stage",
      subtitle: "Four stages with a clear objective, actions, and a concrete way to know whether each one was met.",
    },
    gobierno: {
      eyebrow: "How we are organized",
      title: "Clear rules from day one",
      subtitle: "Assembly, board, sector tables, and technical secretariat: so nobody decides alone and everyone is accountable.",
    },
    afiliacion: {
      eyebrow: "Membership",
      title: "How to join the CEZ",
      subtitle: "Be formally registered and honor what is agreed at the table. Everything else we build along the way.",
    },
  },
  cifras: {
    label: "Founding stage",
    title: "What we are starting with",
    intro:
      "These are first-year goals, not the numbers of an established council. We publish them this way because we would rather you measure whether we deliver.",
    items: [
      { valor: "10", texto: "Municipalities in the Sumapaz province" },
      { valor: "4", texto: "Sectors in the first stage" },
      { valor: "1", texto: "Chapter: Silver Fusagasugá" },
      { valor: "60", texto: "Member companies — first-year goal" },
      { valor: "12", texto: "Business gatherings per year" },
    ],
    nota:
      "The Sumapaz province includes Fusagasugá, Arbeláez, Cabrera, Granada, Pandi, Pasca, San Bernardo, Silvania, Tibacuy, and Venecia.",
  },
  proposito: {
    label: "Who we are",
    title: "A provincial council with its feet on the ground",
    body:
      "Sumapaz is two hours from Bogotá, and that changes everything: our clients, our suppliers, and our competitors are on the other side of the mountain. Every owner faces that alone, negotiates alone, and loses time alone on the same paperwork. The CEZ exists to break that habit. We are not an office that writes reports: we are business owners who sit at the same table, decide what to fight for first, and follow up on what was agreed.",
    pilares: [
      {
        titulo: "One single voice",
        texto:
          "We represent members before municipal governments, the provincial government, the chamber of commerce, and national associations. One letter signed by sixty companies carries different weight than sixty separate letters.",
      },
      {
        titulo: "Business among members",
        texto:
          "Whatever is bought in Bogotá today and could be bought here, gets bought here. We start with the obvious: food, construction, maintenance, transport, and professional services.",
      },
      {
        titulo: "Information to decide",
        texto:
          "A short, honest bulletin every quarter: how employment is doing, what happened to prices, how many visitors came on the weekend, what it costs to build today. Data that fits on one page.",
      },
    ],
  },
  miembros: {
    label: "Members",
    title: "Companies already at the table",
    intro: "These are some of the members driving the CEZ from the founding stage.",
  },
  alianzas: {
    title: "Our agreements and alliances",
    intro: "Institutions we work with to strengthen the Sumapaz province.",
  },
  noticias: {
    title: "News",
    intro: "What is happening in the council and across the Sumapaz province.",
    verMas: "Read article",
    volver: "Back to Who we are",
    clavesLabel: "Key points",
    otrasLabel: "More news",
    porLabel: "By",
  },
  sectores: {
    label: "Our sectors",
    title: "Four sectors, one province",
    intro:
      "We start with four sectors because they generate the most formal employment in Sumapaz and because, properly organized, they buy from each other. Each one has its own table, spokesperson, and task list.",
    mesaLabel: "What the sector table does",
    retosLabel: "What holds us back today",
    items: [
      {
        id: "salud",
        nombre: "Health",
        lema: "Good care is also a serious business",
        porQue:
          "The province serves patients from across the region and welcomes more older adults every year who move here to live. That sustains clinics, care centers, laboratories, pharmacies, therapy practices, and home services.",
        retos: [
          "Payments that arrive late and disrupt the monthly cash position.",
          "Trained staff leaving for Bogotá for better pay.",
          "Licensing requirements each company solves on its own.",
        ],
        mesa: [
          "Negotiate payment terms and conditions as a block with payers.",
          "Train nursing assistants and caregivers locally, with the local academy.",
          "Buy supplies jointly to reduce unit cost.",
        ],
      },
      {
        id: "construccion",
        nombre: "Construction",
        lema: "Growing without ruining the garden that feeds us",
        porQue:
          "Fusagasugá and Silvania have spent years receiving second homes, retirement housing, and countryside projects. Behind every build there are contractors, hardware stores, hauliers, foremen, and local suppliers.",
        retos: [
          "Permits and utilities that decide whether a project starts or stays on paper.",
          "Scarce skilled labor in finishing work and construction safety.",
          "Expensive financing for small and mid-sized builders.",
        ],
        mesa: [
          "A single technical channel with municipal planning and utility companies.",
          "A registry of provincial suppliers and contractors with verified references.",
          "Training in construction safety and finishing work, to stop importing crews.",
        ],
      },
      {
        id: "turismo",
        nombre: "Tourism",
        lema: "Our job is to fill the week, not just Sunday",
        porQue:
          "We sit at Bogotá's doorstep, with steady weather year-round, farms, food, and nature. The problem is not that people do not come: they come packed into two days and leave little behind.",
        retos: [
          "Tight revenue Monday to Friday, with fixed payroll all week.",
          "Informality that punishes those who do comply and invoice.",
          "Scattered promotion: every business advertises alone and competes with its neighbor.",
        ],
        mesa: [
          "Build weekday offerings: long stays, wellness, rest, and corporate events.",
          "Support formalization — registration, insurance, invoicing — without lectures.",
          "Joint promotion in Bogotá under one provincial brand.",
        ],
      },
      {
        id: "agroindustria",
        nombre: "Agribusiness",
        lema: "From the field to a product with its own name",
        porQue:
          "Coffee, blackberries, fruit, panela, dairy, poultry, and flowers. Sumapaz produces well but sells cheap: it ships raw material and buys back the finished product, with the margin already collected by someone else.",
        retos: [
          "Prices decided far away from the farm.",
          "Too many middlemen between the producer and the final client.",
          "Little processing, packaging, or brand of its own.",
        ],
        mesa: [
          "Joint purchase of inputs and packaging, with real negotiating volume.",
          "A Sumapaz origin brand with minimum quality rules.",
          "Sell here: to the province's hotels, restaurants, schools, and care centers.",
        ],
      },
    ],
  },
  capitulo: {
    label: "CEZ chapter",
    title: "Silver Fusagasugá",
    intro:
      "A chapter is a working front where all four sectors serve the same client. This is the first one, and it comes from something you can see on the streets of Fusagasugá every day.",
    queEsTitle: "What it is about",
    queEs: [
      "For decades Fusagasugá has welcomed people who come to live their retirement years: mild weather, close to Bogotá, a calm city. Many arrive with a pension that enters the municipality every month.",
      "We call that the silver economy: everything a city produces to serve older adults well. Housing, health, food, rest, company, and services at home.",
      "This is not social assistance or charity. It is a market that already exists, is served halfway and informally today, and that nobody has organized so far.",
    ],
    porQueTitle: "Why Fusagasugá and why now",
    porQue: [
      {
        titulo: "The income arrives every month",
        texto:
          "A pension does not depend on the harvest, the weather, or a long weekend. It is the most stable income entering the municipality, and it does not leave when the weekend ends.",
      },
      {
        titulo: "The country is aging",
        texto:
          "Every year Colombia has more people over sixty and more people choosing where to spend retirement. Fusagasugá is already on that list; the question is whether it will be ready.",
      },
      {
        titulo: "Today it is improvised",
        texto:
          "Good care, adapted homes, appropriate food, and activities exist, but scattered and without guarantees. That is the opportunity for whoever does it properly.",
      },
      {
        titulo: "It improves the city, not just the business",
        texto:
          "A city that is comfortable for an older adult — good sidewalks, close to everything, calm and safe — is a better city for everyone who lives here.",
      },
    ],
    convergenciaTitle: "How the four sectors come in",
    convergencia: [
      {
        id: "salud",
        titulo: "Health",
        texto:
          "Home care, therapy, check-ups, rehabilitation, and day centers. Service nearby, with staff trained here and clear prices from the start.",
      },
      {
        id: "construccion",
        titulo: "Construction",
        texto:
          "Housing designed for living well at seventy: no unnecessary stairs, non-slip floors, safe bathrooms, good light. Plus retrofitting the homes that already exist.",
      },
      {
        id: "turismo",
        titulo: "Tourism",
        texto:
          "Long stays and weekday rest, not just a Sunday outing. Wellness, hot springs, gentle walks, cultural gatherings, and family visits from Bogotá.",
      },
      {
        id: "agroindustria",
        titulo: "Agribusiness",
        texto:
          "Appropriate food: right portions, less salt and sugar, fresh products from the province, home delivery, and supply to care centers.",
      },
    ],
    ideaSimpleTitle: "The idea in one sentence",
    ideaSimple:
      "One person can be a client of all four sectors in the same month: living in a house we built, cared for by a local health service, eating what is produced here, and resting here. If we organize, that money stays in the province. If we do not, Bogotá takes it.",
    ctaCapitulo: "I want to join the chapter",
  },
  plan: {
    label: "Work plan",
    title: "How we will do it, stage by stage",
    intro:
      "Business councils collapse when they promise everything for year one. This plan has four stages, each with one clear task and a simple way to know whether it was met.",
    objetivoLabel: "What we are aiming for",
    accionesLabel: "What we do",
    medicionLabel: "How we know it worked",
    fases: [
      {
        etiqueta: "Stage 1",
        horizonte: "Months 1 to 3",
        titulo: "Set the table",
        objetivo:
          "Make the council real: written rules, members who actually signed, and a spokesperson per sector.",
        acciones: [
          "Incorporate the CEZ and approve bylaws and a code of conduct.",
          "Build the list of formal companies in the four sectors, municipality by municipality.",
          "Set up the four sector tables and elect a spokesperson for each.",
          "Open the technical secretariat that keeps minutes, accounts, and follow-up.",
        ],
        medicion:
          "Forty companies with a signed letter of intent, and four sector tables meeting with elected spokespeople.",
      },
      {
        etiqueta: "Stage 2",
        horizonte: "Months 4 to 6",
        titulo: "Know where we stand",
        objetivo:
          "Move the conversation from opinions to facts: how many we are, how much employment we create, and how much money leaves the province.",
        acciones: [
          "A short snapshot per sector: number of companies, employment, and approximate sales.",
          "Identify what we buy outside that could already be bought here.",
          "Map what exists today for older adults in Fusagasugá and what is missing.",
          "Publish the first Sumapaz bulletin, one page per sector.",
        ],
        medicion:
          "A brief report per sector, a chapter map, and the first bulletin published.",
      },
      {
        etiqueta: "Stage 3",
        horizonte: "Months 7 to 12",
        titulo: "First deals and first agreements",
        objetivo:
          "Let members see money, not just meetings. This is where a council is won or lost.",
        acciones: [
          "Business matchmaking among members: hotels and care centers buying from provincial producers.",
          "The Silver Fusagasugá seal, with verifiable minimum standards of quality and treatment.",
          "Agreements with the municipal government, the chamber of commerce, and the local academy.",
          "Training in elder care, customer service, and construction safety.",
        ],
        medicion:
          "Value of purchases among members, number of companies holding the seal, and people trained and certified.",
      },
      {
        etiqueta: "Stage 4",
        horizonte: "Year 2",
        titulo: "Make it visible outside",
        objetivo:
          "Put Fusagasugá on the map as the best place in central Colombia to live retirement, and turn that into investment.",
        acciones: [
          "Promote the chapter in Bogotá, with one brand and one spokesperson.",
          "Present concrete projects to investors: housing with services and care centers.",
          "A formal agenda with the provincial government and national sector bodies.",
          "Evaluate results, adjust the plan, and decide the next chapter.",
        ],
        medicion:
          "Weekday visitors, adapted housing units under construction, and investment announced in the province.",
      },
    ],
    nota:
      "Each stage is approved in the general assembly before the next one starts. If something does not work, we say so and fix it; we do not dress it up.",
  },
  gobierno: {
    label: "How we are organized",
    title: "Clear rules from day one",
    intro:
      "Business councils fail for two reasons: nobody is accountable, or one person decides for everyone. This is how we avoid both.",
    organos: [
      {
        titulo: "General assembly",
        texto:
          "It has the final say. It approves the plan, the annual fee, and the accounts. One member, one vote, regardless of company size.",
      },
      {
        titulo: "Board of directors",
        texto:
          "Five to seven people, with at least one spokesperson from each sector. Renewed in halves so new people always come in.",
      },
      {
        titulo: "Sector tables",
        texto:
          "Four tables: health, construction, tourism, and agribusiness. Each sets its three priorities for the year and answers for them.",
      },
      {
        titulo: "Silver Fusagasugá committee",
        texto:
          "The chapter's joint table: the four sectors, the local academy, and the municipal administration as a standing guest.",
      },
      {
        titulo: "Technical secretariat",
        texto:
          "MEU Aliado supports with numbers, reports, and follow-up on commitments. Without a vote in the council's decisions.",
      },
    ],
  },
  afiliacion: {
    label: "Membership",
    title: "How to join the CEZ",
    intro:
      "We ask for two things: be formally registered and honor what is agreed at the table. Everything else we build along the way.",
    beneficiosLabel: "Includes",
    paraLabel: "Who it is for",
    categorias: [
      {
        nombre: "Starter",
        para: "Registered sole proprietors and microbusinesses in the province.",
        destacado: false,
        beneficios: [
          "Quarterly Sumapaz bulletin.",
          "Participation in your sector table.",
          "Preferential rates for training and events.",
          "Basic listing in the member directory.",
        ],
      },
      {
        nombre: "Company",
        para: "Small and mid-sized companies operating in Sumapaz.",
        destacado: true,
        beneficios: [
          "Everything in Starter.",
          "Business matchmaking among members.",
          "The right to speak for your sector table.",
          "Use of the Silver Fusagasugá seal, subject to requirements.",
          "Support with paperwork and public calls.",
        ],
      },
      {
        nombre: "Founder",
        para: "Companies or institutions backing the founding stage.",
        destacado: false,
        beneficios: [
          "Everything in Company.",
          "A seat on the board for the first term.",
          "Brand presence at council events and publications.",
          "Direct agenda in institutional visits.",
          "Permanent recognition as a founder.",
        ],
      },
    ],
    nota:
      "The annual fee is set by the general assembly according to company size, and published together with the year's accounts. Whoever joins in the first year keeps founder status.",
    cta: "Talk about my membership",
  },
  agenda: {
    label: "Calendar",
    title: "What happens during the year",
    intro:
      "A council survives on gatherings that are worth an owner's time. These are the fixed activities on the calendar.",
    items: [
      {
        titulo: "Business breakfast",
        texto:
          "Once a month, early, and ending on time. One topic, one guest, and real time to talk among members.",
      },
      {
        titulo: "Company visit",
        texto:
          "We go to a member's plant, construction site, hotel, or farm. You learn more watching an operation than listening to slides.",
      },
      {
        titulo: "Sector forum",
        texto:
          "One gathering per sector each year, with the authorities who decide and commitments put in writing.",
      },
      {
        titulo: "Business matchmaking",
        texto:
          "Short meetings between buyers and sellers within the council, with the agenda arranged in advance.",
      },
      {
        titulo: "Mission to Bogotá",
        texto:
          "We take the province's offering to buyers, tour operators, and investors in the capital.",
      },
      {
        titulo: "Training",
        texto:
          "Short, practical workshops: elder care, service, costing, construction safety, and cash management.",
      },
    ],
  },
  cierre: {
    title: "Sumapaz does not need another study. It needs to get organized.",
    body:
      "If your company works in health, construction, tourism, or agribusiness and operates in the province, there is a seat for you at the table. Write to us and we will tell you where the founding stage stands.",
    ctaWhatsapp: "Write on WhatsApp",
    ctaCorreo: "Send an email",
    contactoLabel: "Contact",
  },
  footer: {
    direccionLabel: "Address",
    direccion: "Fusagasugá, Sumapaz province",
    lugar: "Cundinamarca, Colombia",
    correoLabel: "Email",
    copyright: "Sumapaz Business Council CEZ — All rights reserved",
    asamblea: "General Assembly of Members 2026",
    ayuda: "Need help?",
    escribenos: "Write to us",
  },
  back: "Back to Business",
};

export const consejoEmpresarialSumapaz = { es, en };
